import { render } from "./ViewPracticePhonemicConsonant.vue?vue&type=template&id=8cdbc072&scoped=true"
import script from "./ViewPracticePhonemicConsonant.vue?vue&type=script&lang=js"
export * from "./ViewPracticePhonemicConsonant.vue?vue&type=script&lang=js"

import "@/css/views/view-practice-phonemic-consonant.css?vue&type=style&index=0&id=8cdbc072&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8cdbc072"]])

export default __exports__